var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-trends"},[_c('div',{staticClass:"event-trends-title"},[_vm._v("事件热度趋势")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"body"},[(_vm.trendData)?_c('line-chart',{attrs:{"data":_vm.trendData}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }